import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "requests" */ '@/views/requests/Index');
export default [
    {
        path: "/requests/:request",
        name: "requests.index",
        component: index,
        meta: {
            middleware: web,
            title: "پردازش درخواست"
        }
    }
]
